import { render } from "./HomeGreetingItemCmp.vue?vue&type=template&id=f5ada1da"
import script from "./HomeGreetingItemCmp.vue?vue&type=script&lang=js"
export * from "./HomeGreetingItemCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__